import { MessageDto, MessageStatusOptions, MessageTypeOptions } from 'common/dto-types/message-dto';
import { SortingType } from 'components/base-table/dto';
import { Column } from 'react-table';
import { SelectColumnFilter } from 'utils/react-table';
import MessageStatusCell from '../../message/components/message-status-cell';
import MessageTypeCell from '../components/message-type-cell';
import DateTimeCell from 'pages/event-list-page/event-table-cells/date-time-cell';
import MessageActionsCell from '../components/message-action-cell';

const MessageTableColumnConfig = [
    {
        Header: 'Id',
        accessor: 'id',
        disableSortBy: false,
    },
    {
        Header: 'Title',
        accessor: 'messageTitle',
        disableFilters: false,
        disableSortBy: true,
    },
    {
        Header: 'Description',
        accessor: 'messageDescription',
        disableFilters: true,
        disableSortBy: true,
    },
    {
        Header: 'Created By',
        id: 'createdBy',
        disableSortBy: false,
        disableFilters: false,
        accessor: (row: MessageDto) => row.createdBy?.trigram,
    },
    {
        Header: 'Last Modified By',
        id: 'lastModifiedBy',
        disableSortBy: false,
        disableFilters: false,
        accessor: (row: MessageDto) => row.lastModifiedBy?.trigram,
    },
    {
        Header: 'Created At (UTC)',
        accessor: 'createdAt',
        disableSortBy: false,
        disableFilters: true,
        Cell: DateTimeCell,
    },
    {
        Header: 'Modified At (UTC)',
        accessor: 'modifiedAt',
        disableSortBy: false,
        disableFilters: true,
        Cell: DateTimeCell,
    },
    {
        Header: 'Published At (UTC)',
        accessor: 'publishedAt',
        disableSortBy: false,
        disableFilters: true,
        Cell: DateTimeCell,
    },
    {
        Header: 'Tournament',
        accessor: (row: MessageDto) => row.tournament?.name,
        disableSortBy: true,
        disableFilters: true,
    },
    {
        Header: 'Type',
        accessor: 'messageType',
        disableSortBy: false,
        Cell: MessageTypeCell,
        Filter: (props) => <SelectColumnFilter {...props} options={MessageTypeOptions} />,
    },
    {
        Header: 'Status',
        accessor: 'status',
        disableSortBy: false,
        filterOptions: MessageStatusOptions,
        Filter: (props) => {
            const options = Array.isArray(props.column.filterOptions)
                ? props.column.filterOptions
                : MessageStatusOptions;
            return <SelectColumnFilter {...props} options={options} />;
        },
        Cell: MessageStatusCell,
    },
    {
        Header: 'Actions',
        id: 'actions',
        disableSortBy: true,
        disableFilters: true,
        Cell: MessageActionsCell,
    },
] as Column[];

export default MessageTableColumnConfig;

export const DefaultVisibleMessageColumns = [
    'id',
    'messageTitle',
    'messageType',
    'status',
    'createdBy',
    'lastModifiedBy',
    'modifiedAt',
    'tournamentName',
    'actions',
];

export const SearchableMessageTableColumnConfig = ['messageTitle', 'createdBy', 'lastModifiedBy', 'tournamentName'];

export const DefaultMessageTableColumnIdToSortBy = 'modifiedAt';
export const DefaultMessageTableSortingType = SortingType.Descending;
